/**
 * URLs for resources served from the Azure blob storage account.
 *
 * Only the host differs per environment (`BLOB_STORAGE_HOST`); every path below has a
 * uniform default and an optional env override for the rare environment whose container
 * is laid out differently.
 *
 * NB! Each `process.env.*` reference here must keep a matching `-replace` line in
 * support/injectGlobalVariables.ps1. Production does not substitute these at build time —
 * the literal text is rewritten in the bundled JS at deploy time, and a token the script
 * misses throws at runtime because the browser has no `process` object.
 */
const host = process.env.BLOB_STORAGE_HOST;

/** Empty when no host is configured, so callers can keep using the URL as a feature guard. */
const buildUrl = (path: string) => (host ? `https://${host}${path}` : '');

export const BLUEBOX_MSG_URL = buildUrl(
  process.env.BLUEBOX_MSG_PATH || '/servicewelt-resources/UnderMaintenance.txt',
);

export const GUIDED_TOUR_BASE_URL = buildUrl(
  process.env.GUIDED_TOUR_PATH || '/servicewelt-resources/tour',
);

export const PRIVACY_POLICY_BASE_URL = buildUrl(
  process.env.PRIVACY_POLICY_PATH || '/web-resources/partnerstiebel/privacy',
);

export const LOGIN_VIDEO_URL = buildUrl(
  process.env.LOGIN_VIDEO_PATH || '/servicewelt-resources/login-background.mp4',
);
